import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

import { createClient } from '../../utils/prismic'
import { getPageData } from '../../utils/getPageData'
import { interpolate } from '../../utils/interpolate'
import { getCheckMyRateUrl } from '../../utils/urlHelpers'
import { useAnalytics } from '../../hooks/useAnalytics'
import useProcessAttributions from '../../hooks/useProcessAttributions'

import NonAPILandingHM from '../../components/landing-hm/non-api-affiliate'
import { NON_API_AFFILIATE_LIST, REVALIDATE_TIME_INTERVAL } from '../../data/constants'

const NonAPIAffiliatePage = (props) => {
  const { payoffLoanData, data, defaultHmData } = props
  const [checkMyRateHref, setCheckMyRateHref] = useState('')

  const router = useRouter()
  const { nonAPIAffiliateUID } = router?.query

  useProcessAttributions()
  useAnalytics('Non_API_Affiliate_Page_Load',
    {
      affiliate: nonAPIAffiliateUID,
    }
  )
  useEffect(() => {
    setCheckMyRateHref(getCheckMyRateUrl())
  }, [nonAPIAffiliateUID])

  return (
    <NonAPILandingHM
      data={data}
      defaultData={defaultHmData}
      payoffLoanData={payoffLoanData}
      checkMyRateHref={checkMyRateHref}
    />
  )
}

export async function getStaticProps({ preview = null, previewData = {} }) {
  const client = createClient({ previewData })
  const { data: { template_variables: templateVarArr } } = await client.getSingle('template-variables')

  if (preview) {
    const [{ data: payoffLoanData }, { data }, { data: defaultHmData }] = await Promise.all([
      client.getByUID('payoff-loan', 'payoff-loan'),
      client.getByUID('affiliate', 'affiliate-default'),
      client.getByUID('dm-landing', 'default-data'),
    ])
    const parsedData = await interpolate(templateVarArr, data)
    const parsedDefaultHmData = await interpolate(templateVarArr, defaultHmData)

    return {
      props: {
        preview,
        data: parsedData,
        defaultHmData: parsedDefaultHmData,
        payoffLoanData
      },
      revalidate: 1,
    }
  }

  const [payoffLoanData, data, defaultHmData] = await Promise.all([
    getPageData({ uid: 'payoff-loan' }),
    getPageData({ uid: 'affiliate-default' }),
    getPageData({ uid: 'default-data' }),
  ])
  const parsedData = await interpolate(templateVarArr, data)
  const parsedDefaultHmData = await interpolate(templateVarArr, defaultHmData)

  return {
    props: {
      data: parsedData,
      defaultHmData: parsedDefaultHmData,
      payoffLoanData
    },
    revalidate: REVALIDATE_TIME_INTERVAL,
  }
}

export async function getStaticPaths() {
  const paths = NON_API_AFFILIATE_LIST.map((nonApiAffiliate) => ({
    params: {
      nonAPIAffiliateUID: nonApiAffiliate,
    },
  }))

  return {
    paths,
    fallback: false,
  }
}

NonAPIAffiliatePage.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  defaultHmData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  payoffLoanData: PropTypes.oneOfType([PropTypes.object]).isRequired,
}

export default NonAPIAffiliatePage
